import { SgvJson } from '@financial/arch';
import { NumberMask } from '@financial/common-utils';

export abstract class Documents {
  abstract get cnp();

  abstract get maskedCnp();

  abstract toJson();

  static fromJson(json: any): Documents {
    if (!json) {
      return null;
    }
    switch (json.type) {
      case 'naturalPerson':
        return NaturalPersonDocuments.fromJson(json);
      case 'legalEntity':
        return LegalEntityDocuments.fromJson(json);
      case 'foreignPerson':
        return ForeignPersonDocuments.fromJson(json);
      default:
        return null;
    }
  }
}

export class NaturalPersonDocuments extends Documents {
  constructor(public cpf = '', public rg = '') {
    super();
  }

  get cnp() {
    return this.cpf;
  }

  get maskedCnp() {
    const cleanCpf = this.cpf.replace(/\D/g, '');
    return NaturalPersonDocuments.MASK.apply(this.cpf);
  }

  static readonly MASK = new NumberMask('999.999.999-99');

  toJson() {
    return SgvJson.to.simple(this, { type: 'naturalPerson' });
  }
  static fromJson(json: any): NaturalPersonDocuments {
    if (!json) {
      return null;
    }
    return SgvJson.from.simple(json, NaturalPersonDocuments);
  }
}

export class LegalEntityDocuments extends Documents {
  constructor(public cnpj = '', public corporateName = '', public ie = '', public im = '') {
    super();
  }

  get cnp() {
    return this.cnpj;
  }

  get maskedCnp() {
    const cleanCnpj = this.cnpj.replace(/\D/g, '');
    return LegalEntityDocuments.MASK.apply(cleanCnpj);
  }

  static readonly MASK = new NumberMask('99.999.999/9999-99');

  toJson() {
    return SgvJson.to.simple(this, { type: 'legalEntity' });
  }
  static fromJson(json: any): LegalEntityDocuments {
    if (!json) {
      return null;
    }
    return SgvJson.from.simple(json, LegalEntityDocuments);
  }
}

export class ForeignPersonDocuments extends Documents {
  constructor(public foreignId = '') {
    super();
  }

  get cnp() {
    return this.foreignId;
  }

  get maskedCnp() {
    return this.foreignId;
  }

  toJson() {
    return SgvJson.to.simple(this, { type: 'foreignPerson' });
  }

  static fromJson(json: any): ForeignPersonDocuments {
    if (!json) {
      return null;
    }
    return SgvJson.from.simple(json, ForeignPersonDocuments);
  }
}
